import {
  Box,
  CircularProgress,
  Collapse,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Menu,
  MenuItem,
  Button,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import BatchColumnStatusRoute from "./BatchColumnStatusRoute";
import {
  dateFormated,
  presentFormatedData,
} from "../functionalComponents/dataFormatFunctions";
import POTabs from "./POTabs";
import axios from "axios";
import { appUrl } from '../../../../../utils/config';
import { fetchUserAssociation, fetchSLFromPODashboard, clearSLFromPODashboard } from "../../../containers/actions/common/purchaseOrderAction";
import jwt_decode from "jwt-decode";
import CollapsePODetails from "./CollapsePODetails";
import EditAboRisk from "./POColumns/EditABORisk";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import AuditReportNew from "./AuditReportNew";
import ViewThreeRecentChanges from "./ViewThreeRecentChanges";
import ViewASNDetails from "./ViewASNDetails";
import ViewReasonCode from "./ViewReasonCode";
// import ApproveRejectConsumedBatch from "./ApproveRejectConsumedBatch";
import VarianceMismatchDialog from "../sasl/deliveryScheduleBatchTable/VarianceMismatchDialog";
import { fetchPOLineAuditDetailsNew } from "../../../containers/actions/common/purchaseOrderNew";
import { FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING } from "../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";
import { useApiBaseUrl } from "../CommonMethods/CommonMethods";
// ----------------------------------------------------------------------
// STYLES
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  tableCellBody: {
    padding: "10px",
  },
  // Columns 1-5 (Icon, PO Number, Product Code / Description, Qty, UOM)
  col1to5: {
    fontSize: "14px",
    
    [theme.breakpoints.up(1680)]: {
      fontSize: "16px",
    },
  },
  // Column 6 (Date)
  col6: {
    fontSize: "14px",
    [theme.breakpoints.up(1680)]: {
      fontSize: "16px",
    },
  },
  col7: {
    "&.MuiTableCell-root": {
      fontSize: "12px",
      [theme.breakpoints.up(1680)]: {
        fontSize: "14px",
      },
    },
  },
  // Columns 8-10 (ABO Risk, PO Status, Action)
  col8to10: {
    "&.MuiTableCell-root": {
      fontSize: "12px", // Default for <1680px
      [theme.breakpoints.up(1680)]: {
        fontSize: "14px", // For >=1680px
      },
    },
    "& .MuiButton-root": {
      fontSize: "inherit !important",
      padding: 0,
      minWidth: 0,
      //fontSize: "inherit",
      backgroundColor: "transparent",
      boxShadow: "none",
      textTransform: "none", // if you want to avoid uppercase
    },
    "& .MuiTextField-root": {
      fontSize: "inherit", // Ensure TextField inherits font size
    },
    "& .MuiSvgIcon-root": {
      fontSize: "inherit", // Ensure icons inherit font size
    },
  },
  tableContainer: {
  },
  title: {
    fontWeight: 500,
    fontSize: "1.5rem",
    textAlign: "left",
    paddingBottom: "0.3rem",
  },
  headerCell: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    height: "28px",
    padding: "10px",
    zIndex: 3,
  },
  groupedHeader: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    textAlign: "center",
    whiteSpace: "nowrap",
    height: "28px",
    position: "sticky",
    padding: "10px",
    top: 0,
    zIndex: 3,
    border: "none",
    paddingBottom: "0px",
  },

}));
const renderPOStatusButton = (statusID, statusText) => {
  let color;
  switch (statusID) {
    case 21: // Created
      color = "#B4B4B4";
      break;
    case 23: // Under confirmation
      color = "#E78A00";
      break;
    case 22: // Shared with CMO
      color = "#2196F3";
      break;
    case 25: // Confirmed
    case 29: // Under Revision
    case 31: // Revised
    case 27: // Approved
      color = "#329429";
      break;
    case 30: // Delivery Complete
      color = "#707070";
      break;
    case 24: // Rejected By CMO
      color = "#FF0000";
      break;
    default:
      color = "#1E1E1E";
  }

  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: "nowrap",
        // fontSize: "inherit",
      }}
    >
      {statusText}
    </Typography>
  );
};

const PurchaseOrderTabTable = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    fetchPurchaseOrderDataLoading,
    rowData,
    errors,
    handleRefresh,
    handleQuickSummaryRefresh,
    selectedPO,
    setSelectedPO,
    featuresAccess,
    selectedCMOs,
    selectedBrands,
  } = props;

  const [poData, setPOData] = useState(rowData);
  const [rowInfo, setRowInfo] = useState(null);
  const [open, setOpen] = useState({}); // tracks row expansions
  const [openedPOTab, setOpenedPOTab] = useState({});
  const [openAction, setOpenAction] = useState(false);
  const [openReasonCode, setOpenReasonCode] = useState(false);
  const [openASN, setOpenASN] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPoHistory, setOpenPoHistory] = useState(false);
  const [openApproveRejectBatch, setOpenApproveRejectBatch] = useState(false);
  const prevLoadingRef = useRef(false); // Track previous loading state to detect refresh completion
  
  const openMenu = Boolean(anchorEl);
  const userAssociationData = useSelector(
    state => state.pcmp?.common?.purchaseOrder?.userAssociationResult || null
  );
  
  // SL Details from PO Dashboard
  const slDetailsFromPODashboard = useSelector(
    (state) => state?.pcmp?.common?.purchaseOrder?.slDetailsFromPODashboard || {}
  );
  const slDetailsFromPODashboardLoading = useSelector(
    (state) => state?.pcmp?.common?.purchaseOrder?.slDetailsFromPODashboardLoading
  );




  const isUserAssociatedWithAnyPO = (rowData, userAssociationData) => {
    if (!Array.isArray(rowData) || !userAssociationData) {
      return false;
    }

    // Handle both direct data and nested data structure
    const associations = userAssociationData.data || userAssociationData;
    
    const {
      associatedProductTypesList = [],
      associatedBrandList = [],
      associatedCMOList = [],
    } = associations;

  
    return rowData.some(poItem => {
      const scheduleLine = poItem.scheduleLineDetails;
      if (!scheduleLine) return false;
      const productTypeID = scheduleLine.productTypeID;
      const brand = scheduleLine.brand;
      const vendorMosymphonyID = scheduleLine.vendorMosymphonyID;

  
      const isProductTypeMatched = associatedProductTypesList.includes(productTypeID);

      const isBrandMatched = associatedBrandList.some(b => b?.trim()?.toUpperCase() === brand?.trim()?.toUpperCase());
      const isVendorMatched = associatedCMOList.includes(vendorMosymphonyID);
      
      
      return isProductTypeMatched && isBrandMatched && isVendorMatched;
    });
  };
  
  // Extract schedule line details from slDetailsFromPODashboard
  const slDetailsData = Object.values(slDetailsFromPODashboard)
    .filter(item => item?.data?.scheduleLineDetails)
    .map(item => ({ scheduleLineDetails: item.data.scheduleLineDetails }));
  
  const showPencilIcon = isUserAssociatedWithAnyPO(
    slDetailsData.length > 0 ? slDetailsData : rowData,
    userAssociationData
  )


  const poLineAuditsNewData = useSelector(
    (state) => state?.pcmp?.common?.poNew?.poLineAuditsNew
  );
  const poLineAuditsNewDataLoading = useSelector(
    (state) => state?.pcmp?.common?.poNew?.poLineAuditsNewLoading
  );


  // Action button click
  const handleClick = (event, row, index) => {
    setAnchorEl(event.currentTarget);
    setRowInfo(row);
    // We are no longer setting selectedPO here, so it doesn't hide other rows
  };


  const token = localStorage.getItem('authToken');
  useEffect(() => {
    if (token) {
      try {
        const payload = jwt_decode(token);

        // If userAssociationData is not loaded, fetch it
        if (!userAssociationData && payload.saas_user_id) {
          dispatch(fetchUserAssociation(payload.saas_user_id))
            .catch((error) => {
              console.error("Error fetching user associations:", error);
            });
        }
      } catch (e) {
        console.error('Invalid token', e);
      }
    }
  }, [token, userAssociationData, dispatch]);
  // Action menu close
  const handleClose = () => {
    setAnchorEl(null);
  };


 

  useEffect(() => {
    if (selectedPO === null) {
      // Close all expanded rows
      setOpen({});
    }
  }, [selectedPO]);

  
  const handleRowToggle = (poNumber, schrockenSLID) => {
    // Toggle the open state for this row
    const isOpening = !open[poNumber];
    
    setOpen((prevState) => ({
      ...prevState,
      [poNumber]: !prevState[poNumber],
    }));

    // If we are opening this row, set selectedPO to its ID (focus mode)
    // If we are closing it, set selectedPO back to null (show all rows)
    const newSelectedPO = open[poNumber] ? null : poNumber;
    setSelectedPO(newSelectedPO);

    // Tell parent component about focus mode change
    props.onFocusModeChange(newSelectedPO !== null);

    // Reset the opened tab to 0
    setOpenedPOTab((prevState) => ({
      ...prevState,
      [poNumber]: 0,
    }));

    // If opening the row, clear props data first, then fetch fresh data
    if (isOpening && schrockenSLID) {
      // Clear props data for this SL to ensure fresh fetch
      dispatch(clearSLFromPODashboard(schrockenSLID));
      // Fetch fresh SL details
      dispatch(fetchSLFromPODashboard(schrockenSLID))
        .catch((error) => {
          console.error("Failed to fetch SL details for", schrockenSLID, error);
        });
    }
    
    // If closing the row, clear props data for this SL
    if (!isOpening && schrockenSLID) {
      dispatch(clearSLFromPODashboard(schrockenSLID));
    }
  };

  // Switch between tabs inside the expanded row
  const handleOpenPOTab = (poNumber, val) => {
    setOpenedPOTab((prevState) => ({
      ...prevState,
      [poNumber]: val,
    }));
  };

  // Open PO history
  const handleOpenPoHistory = () => {
    setOpenPoHistory(true);
    setAnchorEl(null);
  };

  // Open three most recent changes
  const handleOpenAction = () => {
    setAnchorEl(null);
    setOpenAction(true);
  };

  // Open reason code
  const handleopenReasonCodes = () => {
    setAnchorEl(null);
    setOpenReasonCode(true);
  };



  // Open Approve/Reject Consumed Batch
  const handleApproveRejectBatchOpen = () => {
    setAnchorEl(null);
    setOpenApproveRejectBatch(true);
  };

  useEffect(() => {
    setPOData(rowData);
  }, [rowData, fetchPurchaseOrderDataLoading]);

  // Re-fetch SL details for all open rows after refresh completes
  useEffect(() => {
    // Only fetch when loading transitions from true to false (refresh just completed)
    const wasLoading = prevLoadingRef.current;
    const isLoading = fetchPurchaseOrderDataLoading;
    
    // Update ref for next comparison
    prevLoadingRef.current = isLoading;
    
    // Only proceed if we just finished loading (was loading, now not loading)
    if (wasLoading && !isLoading && rowData && rowData.length > 0) {
      // Get all open rows
      const openRows = Object.keys(open).filter(poNumber => open[poNumber]);
      
      if (openRows.length > 0) {
        // Find schrockenSLIDs for all open rows and fetch fresh data
        const schrockenSLIDsToFetch = [];
        rowData.forEach(row => {
          const poNumber = row?.scheduleLineDetails?.scheduleAgreementNumber || "NA";
          if (openRows.includes(poNumber)) {
            const schrockenSLID = row?.scheduleLineDetails?.schrockenSLID;
            if (schrockenSLID) {
              schrockenSLIDsToFetch.push(schrockenSLID);
            }
          }
        });

        // Clear props data and fetch fresh for all open rows
        schrockenSLIDsToFetch.forEach(schrockenSLID => {
          dispatch(clearSLFromPODashboard(schrockenSLID));
          dispatch(fetchSLFromPODashboard(schrockenSLID))
            .catch((error) => {
              console.error("Failed to refresh SL details for", schrockenSLID, error);
            });
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPurchaseOrderDataLoading, rowData]);

  useEffect(() => {
    if (openPoHistory) {
      dispatch({
        type: FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING,
        payload: true,
      });
      dispatch(
        fetchPOLineAuditDetailsNew({
          schrockenSLID: rowInfo?.scheduleLineDetails?.schrockenSLID || "",
          viewRecentChanges: false,
        })
      );
    }
  }, [openPoHistory, dispatch, rowInfo]);

  useEffect(() => {
    if (openAction) {
      dispatch({
        type: FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING,
        payload: true,
      });
      dispatch(
        fetchPOLineAuditDetailsNew({
          schrockenSLID: rowInfo?.scheduleLineDetails?.schrockenSLID || "",
          viewRecentChanges: true,
        })
      );
    }
  }, [openAction, dispatch, rowInfo]);

  // --------------------------------------------------------------------
  // RENDER
  // --------------------------------------------------------------------
  return (
    <>
      <TableContainer
        style={{
          marginTop: "1rem",
          minHeight: "auto",
        }}
        component={Paper}
        className={classes.tableContainer}
      >
        <Table  style={{ borderCollapse: "collapse" }}>
          <TableHead className={`${classes.headerCell} default-table-styles`}>
            <TableRow>
              <TableCell className={`${classes.headerCell} ${classes.columnExpand}`} rowSpan={2} />
              <TableCell
                className={`${classes.headerCell} ${classes.columnPONumber}`}
                rowSpan={2}
                align="left"
              >
                {localStorage.getItem("collabType") !== "CMO" ? "PO Number" : "SO Number"}

              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnProduct}`}
                rowSpan={2}
                align="left"
              >
                Product Code / Description
              </TableCell>
              <TableCell
                className={classes.groupedHeader}
                colSpan={3}
                align="center"
              >
                Current Values
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnBatchStatus}`}
                rowSpan={2}
                align="center"
              >
                Batch Status
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnABORisk}`}
                rowSpan={2}
                align="left"
              >
                {localStorage.getItem("collabType") !== "CMO" ? "Priority" : "Priority"}

              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnPOStatus}`}
                rowSpan={2}
                align="center"
              >
                {localStorage.getItem("collabType") !== "CMO" ? "PO Status" : "SO Status"}
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnAction}`}
                rowSpan={2}
                align="center"
              >
                Action
              </TableCell>
            </TableRow>
            <TableRow>
              {/* Subheaders */}
              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px" }}
                className={`${classes.headerCell} ${classes.columnQty}`}
              >
                Qty
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={`${classes.headerCell} ${classes.columnUOM}`}
              >
                UoM
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={`${classes.headerCell} ${classes.columnDate}`}
              >
                Date
              </TableCell>
            </TableRow>
          </TableHead>

          {/* TABLE BODY */}
          {fetchPurchaseOrderDataLoading ? (
            <TableBody>
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={10}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : errors?.status === false ? (
            <TableBody>
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  textAlign: "center",
                  padding: "0.8rem",
                  //fontSize: "0.875rem",
                }}
              >
                <TableCell
                  colSpan={10}
                  align="center"
                  style={{ padding: "10px" }}
                >
                  Something went wrong. Please try again later.
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {/* No Data Case */}
              {poData?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}

              {/* Main Rows */}
              {poData.map((row, index) => {
                const poNumber =
                  row?.scheduleLineDetails?.scheduleAgreementNumber || "NA";

                // If a PO is selected (expanded) and this row is NOT the selected one, hide it.
                if (selectedPO && poNumber !== selectedPO) {
                  return null;
                }

                return (
                  <React.Fragment key={`row-${index}`}>
                    <TableRow>
                      <TableCell className={`${classes.tableCellBody} ${classes.col1to5}`}>
                        <IconButton
                          onClick={() => handleRowToggle(poNumber, row?.scheduleLineDetails?.schrockenSLID)}
                          size="small"
                        >
                          {open[poNumber] && selectedPO !== null ? (
                            <ExpandMoreIcon />
                          ) : (
                            <ChevronRightIcon />
                          )}
                        </IconButton>
                      </TableCell>

                      <TableCell className={`${classes.tableCellBody} ${classes.col1to5}`}>
                        {localStorage.getItem("collabType") !== "CMO" ? <> {presentFormatedData(poNumber, "NA")} - {presentFormatedData(row?.scheduleLineDetails?.scheduleLineItemNumber, "NA")} </> : <>{presentFormatedData(row?.scheduleLineDetails?.cmoSalesOrderNumber, "NA")} - {presentFormatedData(row?.scheduleLineDetails?.scheduleLineItemNumber, "NA")} <br />PO: {presentFormatedData(poNumber, "NA")} - {presentFormatedData(row?.scheduleLineDetails?.scheduleLineItemNumber, "NA")}</>}
                      </TableCell>

                      <TableCell className={`${classes.tableCellBody} ${classes.col1to5}`}>
                        {row?.scheduleLineDetails?.fgMaterialCode &&
                          row?.scheduleLineDetails?.fgMaterialName ? (
                          <>
                            {presentFormatedData(
                              row?.scheduleLineDetails?.fgMaterialCode
                            )}
                            <br />
                            {presentFormatedData(
                              row?.scheduleLineDetails?.fgMaterialName
                            )}
                          </>
                        ) : (
                          "NA"
                        )}
                      </TableCell>

                      <TableCell
                        align="right"
                        className={`${classes.tableCellBody} ${classes.col1to5}`}
                        style={{
                          whiteSpace: "nowrap",
                          color: (() => {
                            
                            const targetQuantity = row?.scheduleLineDetails?.targetQuantity;
                            const committedQuantity = row?.scheduleLineDetails?.committedQuantity;
                            const activeRejectionFlag = row?.scheduleLineDetails?.activeRejectionFlag;
                            
                           
                            const acceptanceLimitForMore = row?.scheduleLineDetails?.acceptanceLimitForMoreDeliveryQuantityChangeByCMO ?? 0;
                            const acceptanceLimitForLess = row?.scheduleLineDetails?.acceptanceLimitForLessDeliveryQuantityChangeByCMO ?? 0;
                          
                            
                            if (
                              targetQuantity == null || 
                              committedQuantity == null || 
                              targetQuantity <= 0 || 
                              committedQuantity < 0
                            ) {
                              return "black";
                            }
                          
                           
                            if (activeRejectionFlag !== true) {
                              return "black";
                            }
                          
                            
                            const lowerDelta = (targetQuantity * acceptanceLimitForLess) / 100;
                            const upperDelta = (targetQuantity * acceptanceLimitForMore) / 100;
                            
                            const lowerBound = targetQuantity - lowerDelta;
                            const upperBound = targetQuantity + upperDelta;
                          
                          
                            if (committedQuantity === targetQuantity) {
                              return "black";
                            }
                          
                            
                            if (committedQuantity >= lowerBound && committedQuantity <= upperBound) {
                              return "black";
                            }
                          
                           
                            return "red";
                          })(),
                        }}
                      >
                        {presentFormatedData(
                          row?.scheduleLineDetails?.committedQuantity,
                          "NA"
                        )}
                      </TableCell>

                      <TableCell
                        align="left"
                        className={`${classes.tableCellBody} ${classes.col1to5}`}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {presentFormatedData(
                          row?.scheduleLineDetails?.targetQuantityUOM
                        )}
                      </TableCell>

                      <TableCell
                        align="left"
                        className={`${classes.tableCellBody} ${classes.col1to5}`}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {(() => {
                          const statisticalDate = row?.scheduleLineDetails?.statisticalDate;
                          const committedDeliveryDate = row?.scheduleLineDetails?.committedDeliveryDate;
                          const activeRejectionFlag = row?.scheduleLineDetails?.activeRejectionFlag;
                          const acceptanceLimitForLaterDeliveryDateChangeByCMO = 
                            row?.scheduleLineDetails?.acceptanceLimitForLaterDeliveryDateChangeByCMO || 0;

                         
                          const shouldHighlightDateRed = (() => {
                            if (!statisticalDate || !committedDeliveryDate || activeRejectionFlag !== true) {
                              return false;
                            }

                            const committedDate = new Date(committedDeliveryDate);
                            const statDate = new Date(statisticalDate);

                            const lateBoundaryDate = new Date(committedDate);
                            lateBoundaryDate.setDate(lateBoundaryDate.getDate() - acceptanceLimitForLaterDeliveryDateChangeByCMO);

                            return lateBoundaryDate.getTime() > statDate.getTime();
                          })();

                          return (
                            <span
                              style={{
                                color: shouldHighlightDateRed ? "red" : "black",
                              }}
                            >
                              {dateFormated(
                                committedDeliveryDate,
                                "DD-MMM-YYYY",
                                "NA"
                              )}
                            </span>
                          );
                        })()}
                      </TableCell>

                      <TableCell
                        align="center"
                        className={`${classes.tableCellBody} ${classes.col1to5}`}
                      >
                        {row?.batchDetails &&
                          Object.keys(row?.batchDetails).length > 0 ? (
                          <BatchColumnStatusRoute 
                            poDashboardBatch={true} 
                            featuresAccess={featuresAccess} 
                            row={row} 
                            slDetailsData={slDetailsFromPODashboard[row?.scheduleLineDetails?.schrockenSLID]?.data}
                          />
                        ) : (
                          "NA"
                        )}
                      </TableCell>

                      {/* ABO Risk */}
                      <TableCell align="left" className={classes.tableCellBody}>
                        <EditAboRisk row={row} handleRefresh={handleRefresh} featuresAccess={featuresAccess} userAssociations={userAssociationData} selectedCMOs={selectedCMOs}
    selectedBrands={selectedBrands} col8to10Style={classes.col8to10} showPencilIcon={showPencilIcon}/>
                      </TableCell>

                      {/* PO Status */}
                      <TableCell className={`${classes.tableCellBody} ${classes.col8to10}`}>
                        {renderPOStatusButton(
                          row?.scheduleLineDetails?.scheduleLineStatusID,
                          row?.scheduleLineDetails?.scheduleLineStatusText
                        )}
                      </TableCell>

                      {/* Action Button (dropdown menu) */}
                      <TableCell
                        align="center"
                        style={{ textAlign: "center" }}
                        className={`${classes.tableCellBody} ${classes.col8to10}`}
                      >
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Button
                            onClick={(e) => handleClick(e, row, index)}
                            className="classes.col8to10"
                            style={{
                             
                              backgroundColor: "black",
                              color: "white",
                              textTransform: "none",
                              borderRadius: "20px",
                              padding: "8px 16px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              
                            }}
                          >
                            Choose the action
                            <KeyboardArrowDownIcon
                              style={{ fontSize: "20px", fontWeight: "bold" }}
                            />
                          </Button>
                        </div>
                        <Menu
                          anchorEl={anchorEl}
                          open={openMenu}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          getContentAnchorEl={null}
                          PaperProps={{
                            style: {
                              backgroundColor: "black",
                              color: "white",
                              borderRadius: "8px",
                              width: "12rem",
                              marginTop: "8px",
                            },
                          }}
                        >
                          {featuresAccess?.actionViewPoHistory && (
                            <MenuItem
                              onClick={() => handleOpenPoHistory()}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              View {localStorage.getItem("collabType") !== "CMO" ? "PO" : "SO"} History
                            </MenuItem>
                          )}
                          {featuresAccess?.actionMostRecentChanges && (
                            <MenuItem
                              onClick={() => handleOpenAction()}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              View Three Most
                              <br /> Recent Changes
                            </MenuItem>
                          )}
                          {/* Example of conditionally showing "View ASN" */}
                          {/* {(rowInfo?.scheduleLineDetails
                            ?.scheduleLineStatusID === 25 ||
                            rowInfo?.scheduleLineDetails
                              ?.scheduleLineStatusID === 29 ||
                            rowInfo?.scheduleLineDetails
                              ?.scheduleLineStatusID === 30 ||
                            rowInfo?.scheduleLineDetails
                              ?.scheduleLineStatusID === 31) &&
                            (rowInfo?.batchDetails?.batchStatusID >= 48) && featuresAccess?.actionViewASN && (
                              <MenuItem
                                onClick={() => handleASNOpen()}
                                style={{ color: "white", fontSize: "14px" }}
                              >
                                View ASN
                              </MenuItem>
                            )} */}
                          {featuresAccess?.actionViewReasonCodes && (
                            <MenuItem
                              onClick={() => handleopenReasonCodes()}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              View Reason Codes
                            </MenuItem>
                          )}
                          {(rowInfo?.batchDetails?.batchStatusID === 40 && featuresAccess?.viewApproveRejectConsumedBatch) && (
                            <MenuItem
                              onClick={() => handleApproveRejectBatchOpen()}
                              style={{ color: "white", fontSize: "14px", textWrap: "auto" }}
                            >
                              Review variance/mismatch
                            </MenuItem>
                          )} 
                        </Menu>
                      </TableCell>
                    </TableRow>

                    {/* Collapsible Details */}
                    <TableRow>
                      <TableCell colSpan={10} style={{ padding: 0 }}>
                        <CollapsePODetails
                          open={open[poNumber]}
                          row={row}
                          handleRefresh={handleRefresh}
                          handleQuickSummaryRefresh={handleQuickSummaryRefresh}
                          openedPOTab={openedPOTab[poNumber]}
                          showPencilIcon={showPencilIcon}
                          handleOpenPOTab={(val) =>
                            handleOpenPOTab(poNumber, val)
                          }
                          slDetails={slDetailsFromPODashboard[row?.scheduleLineDetails?.schrockenSLID]}
                          slDetailsLoading={slDetailsFromPODashboardLoading}
                        />
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <Dialog
        fullScreen
        open={openPoHistory}
        onClose={() => setOpenPoHistory(false)}
      >
        <DialogContent>
          <AuditReportNew
            rowInfo={rowInfo}
            poLineAuditsNewData={poLineAuditsNewData}
            poLineAuditsNewDataLoading={poLineAuditsNewDataLoading}
            setOpenPoHistory={setOpenPoHistory}
          />
        </DialogContent>
      </Dialog>

      {openAction && (
        <ViewThreeRecentChanges
          openAction={openAction}
          setOpenAction={setOpenAction}
          rowInfo={rowInfo}
          poLineAuditsNewData={poLineAuditsNewData}
          poLineAuditsNewDataLoading={poLineAuditsNewDataLoading}
        />
      )}

      {openASN && (
        <ViewASNDetails
          openASN={openASN}
          setOpenASN={setOpenASN}
          rowInfo={rowInfo}
        />
      )}

      {openReasonCode && (
        <ViewReasonCode
          openReasonCode={openReasonCode}
          setOpenReasonCode={setOpenReasonCode}
          rowInfo={rowInfo}
        />
      )}

     
      {/* {openApproveRejectBatch && (
        <ApproveRejectConsumedBatch
          open={openApproveRejectBatch}
          onClose={() => setOpenApproveRejectBatch(false)}
          rowInfo={rowInfo}
          onRefresh={handleRefresh}
          source="poDashboard"
        />
      )} */}

      <VarianceMismatchDialog
        open={openApproveRejectBatch}
        handleClose={() => setOpenApproveRejectBatch(false)}
        row={rowInfo ? {
          ...rowInfo.batchDetails,
          ...rowInfo.scheduleLineDetails,
          vendorName: rowInfo.scheduleLineDetails?.vendorName || rowInfo.scheduleLineDetails?.cmoName,
          batchUOM: rowInfo.batchDetails?.batchUOM || rowInfo.scheduleLineDetails?.targetQuantityUOM,
          // from batchDetails
          producedQuantity: rowInfo.batchDetails?.producedQuantity ?? null,
          reviewVarianceReqd: rowInfo.batchDetails?.reviewVarianceReqd ?? false,
          consumptionSameAsAllocation: rowInfo.batchDetails?.consumptionSameAsAllocation ?? false,
          // from scheduleLineDetails
          producedQtyVariancePresent: rowInfo.scheduleLineDetails?.producedQtyVariancePresent ?? false,
          producedQtyVarianceValue: rowInfo.scheduleLineDetails?.producedQtyVarianceValue ?? null,
          statDateVariancePresent: rowInfo.scheduleLineDetails?.statDateVariancePresent ?? false,
          poQuantity: rowInfo.scheduleLineDetails?.poQuantity ?? rowInfo.scheduleLineDetails?.targetQuantity ?? 0,
        } : null}
        onRefreshData={handleRefresh}
      />

    </>
  );
};

export default PurchaseOrderTabTable;
